import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-date-picker";
import TimePicker from 'react-time-picker';
import "./V730iPatientHistory.scss";
import { connect } from "react-redux";
import patientTypeAdult from "../../../common/images/patient_type_adult.png";
import patientTypePediatric from "../../../common/images/patient_type_pediatric.png";
import patientTypeNeonatal from "../../../common/images/patient_type_neonatal.png";
import { v730iGraphTypes, DurationOptionList } from "../../../common/constant/common-constants";
import { MODE } from "../../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { VENTILATOR_ADDITIONAL_FEATURES } from "../../../common/ENUMS/PARAMETER_ENUM";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";
import priority_high_svg from "../../../common/icons/svg/priority-high.svg";
import priority_medium_svg from "../../../common/icons/svg/priority-medium.svg";
import priority_low_svg from "../../../common/icons/svg/priority-low.svg";
import moment from "moment";
import V730iParameterGraph from "./V730iParameterGraph";
import V730iSetParameterHistory from "./V730iSetParameterHistory";
import V730iEventHistory from "./V730iEventHistory";
import { ventilatorPatientHistoryPatientModeAPData, ventilatorPatientHistoryTimeData, ventilatorPatientHistoryLiveAlarmHistoryData, ventilatorPatientHistoryAdditionalFeaturesData } from "../../../modules/actions/action";
import { getV730iPatientHistoryPatientModeAPData, getV730iPatientHistoryLiveAlarmHistoryData, getV730iPatientHistoryAdditionalFeaturesHistoryData } from "../../../helper/patient-history-helper";
import lung_svg from "../../../common/icons/svg/lungs.svg";
import consolidation_svg from "../../../common/icons/svg/consolidation.svg"


function V730iPatientHistory(props) {

    const [showMoreVentilatorAlarms, setShowMoreVentilatorAlarms] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [Isduration_custom, setIsduration_custom] = useState(null);
    const [duration, setduration] = useState(null);
    const [isCustomPopupVisible, setIsCustomPopupVisible] = useState(false);
    const dropdownRef = useRef(null);

    //PatientHistory-----TimeDetails
    const [trendStartDate, setTrendStartDate] = useState(null);
    const [trendEndDate, setTrendEndDate] = useState(null);
    const [trendStartTime, setTrendStartTime] = useState(moment(null));
    const [trendEndTime, setTrendEndTime] = useState(null);

    const graphTypes = [
        {
            key: "all", label: "All", width: "1.98vw", parameterList: [
                ...v730iGraphTypes.PRESSURE,
                ...v730iGraphTypes.SPO2,
                ...v730iGraphTypes.ETCO2,
                ...v730iGraphTypes.LUNG_DYNAMICS
            ]
        },
        { key: "pressure", label: "Pressure", width: "3.96vw", parameterList: v730iGraphTypes.PRESSURE },
        { key: "spo2", label: "SPO2", width: "2.86vw", parameterList: v730iGraphTypes.SPO2 },
        { key: "etco2", label: "ETCO2", width: "3.13vw", parameterList: v730iGraphTypes.ETCO2 },
        { key: "lungdynamics", label: "Lung Dynamics", width: "6.09vw", parameterList: v730iGraphTypes.LUNG_DYNAMICS },

    ];
    const [selectGraphType, setselectGraphType] = useState(graphTypes[0]);

    //PatientHistory----PatientModeAPDetails
    const [patientModeAPData, setPatientModeAPData] = useState({});
    const [patientId, setPatientId] = useState(null);
    const [patientTypeImg, setPatientTypeImg] = useState(null);
    const [modeName, setModeName] = useState(null);
    const [currentCursorTimeModePacket, setCurrentCursorTimeModePacket] = useState(null);

    //PatientHistory----LiveAlarmHistoryDetails
    const [liveAlarmHistory, setLiveAlarmHistory] = useState(null)
    const [currentLiveAlarmPacket, setCurrentLiveAlarmPacket] = useState([]);

    //PatientHistory----AdditionalFeaturesHDetails
    const [additionalFeaturesHistory, setAdditionalFeaturesHistory] = useState([]);
    const [currentAdditionalFeaturesPacket, setCurrentAdditionalFeaturesPacket] = useState({})



    //Helper Functions
    const getPriority = (priority) => {
        let pr = priority?.toUpperCase();
        switch (pr) {
            case "HIGH":
                return { icon: priority_high_svg, color: '#AD0606', textColor: '#fff' };
            case "MEDIUM":
                return { icon: priority_medium_svg, color: '#FCC331', textColor: '#000' };
            case "LOW":
                return { icon: priority_low_svg, color: '#3ADAE5', textColor: '#000' };
            default:
                return { icon: '', color: '#3ADAE5' };
        }
    }

    const handleShowMoreVentilatorAlarmsClick = (event) => {
        event.stopPropagation();
        setShowMoreVentilatorAlarms(!showMoreVentilatorAlarms);
    };

 

    const getTrendIntervals = (durationValue) => {
        // durationValue is now in minutes
        const durationMinutes = parseInt(durationValue, 10);
        const now = new Date();

        const endDate = now;
        const startDate = new Date(
            now.getTime() - durationMinutes * 60 * 1000
        );

        const startTime = moment(startDate).format("HH:mm:ss");
        const endTime = moment(endDate).format("HH:mm:ss");

        return {
            startDate,
            startTime,
            endDate,
            endTime
        };
    };

    function combineToUTC(startDate, endDate, startTime, endTime) {


        const startDatetime = moment.utc(`${startDate} ${startTime}`, "YYYY-MM-DD HH:mm:ss");
        const endDatetime = moment.utc(`${endDate} ${endTime}`, "YYYY-MM-DD HH:mm:ss");

        //Convert to UTC 
        const utc_startDatetime = startDatetime.clone().subtract(5, 'hours').subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss') + '+00';
        const utc_endDatetime = endDatetime.clone().subtract(5, 'hours').subtract(30, 'minutes').format('YYYY-MM-DD HH:mm:ss') + '+00';

        return {
            utc_startDatetime,
            utc_endDatetime
        }

    }
    const calculateTimestamps = (isdurationCustom, duration) => {

        let finalTimeIntervals = null
        let timeData = {
            bedId: props?.bedId,
            duration: isdurationCustom ? "Custom" : duration,
        }

        if (isdurationCustom) {
            // console.log("Custom")
            // console.log(moment(trendStartDate).format("YYYY-MM-DD"))
            // console.log(moment(trendEndDate).format("YYYY-MM-DD"))
            // console.log(trendStartTime)
            // console.log(trendEndTime)

            finalTimeIntervals = combineToUTC(
                moment(trendStartDate).format("YYYY-MM-DD"),
                moment(trendEndDate).format("YYYY-MM-DD"),
                trendStartTime,
                trendEndTime)

            // console.log(finalTimeIntervals.utc_startDatetime)
            // console.log(finalTimeIntervals.utc_endDatetime)

            timeData.startDate = trendStartDate
            timeData.startTime = trendStartTime
            timeData.endDate = trendEndDate
            timeData.endTime = trendEndTime
            timeData.startDateTime = finalTimeIntervals?.utc_startDatetime
            timeData.endDateTime = finalTimeIntervals?.utc_endDatetime


        }
        else if (!isdurationCustom && duration) {
            // console.log("Duration", duration)
            const trendIntervals = getTrendIntervals(duration)

            // console.log(moment(trendIntervals.startDate).format("YYYY-MM-DD"))
            // console.log(moment(trendIntervals.endDate).format("YYYY-MM-DD"))
            // console.log(trendIntervals.startTime)
            // console.log(trendIntervals.endTime)

            finalTimeIntervals = combineToUTC(
                moment(trendIntervals?.startDate).format("YYYY-MM-DD"),
                moment(trendIntervals?.endDate).format("YYYY-MM-DD"),
                trendIntervals?.startTime,
                trendIntervals?.endTime)

            // console.log(finalTimeIntervals.utc_startDatetime)
            // console.log(finalTimeIntervals.utc_endDatetime)

            timeData.startDate = trendIntervals?.startDate
            timeData.startTime = trendIntervals.startTime
            timeData.endDate = trendIntervals?.endDate
            timeData.endTime = trendIntervals?.endTime
            timeData.startDateTime = finalTimeIntervals?.utc_startDatetime
            timeData.endDateTime = finalTimeIntervals?.utc_endDatetime

        }
        // console.log("timeData", timeData)
        props.ventilatorPatientHistoryTimeData(timeData) // Dispatch to redux

    }
    const showCustomPopup = () => {
        setIsCustomPopupVisible(true);
    };
    const hideCustomPopup_onclick = () => {
        setIsCustomPopupVisible(false);
        // setduration(null)
        // setIsduration_custom(true)
        calculateTimestamps(true, null);
    };
    const hideCustomPopup_cancel = () => {
        setIsCustomPopupVisible(false);
    };



    //Algos to find current Packet
    const findPacketBinarySearch = (current, list) => {
        // ----- BINARY SEARCH -----
        let left = 0;
        let right = list.length - 1;
        let found = null;

        while (left <= right) {
            const mid = Math.floor((left + right) / 2);
            const item = list[mid];

            const start = new Date(item.startTime).getTime();
            const end = item.endTime ? new Date(item.endTime).getTime() : Infinity;

            if (current >= start && current <= end) {
                found = item;
                break;
            }

            if (current < start) {
                right = mid - 1;
            } else {
                left = mid + 1;
            }
        }

        return found;
    }
    function findRawliveAlarmsPacket(current, list) {
        const start = current - 2000;
        const end = current + 2000;

        // --- binary search: first index >= start ---
        let left = 0, right = list.length - 1;
        let startIdx = list.length;

        while (left <= right) {
            let mid = (left + right) >> 1;
            let ts = new Date(list[mid].observedTime).getTime();

            if (ts >= start) {
                startIdx = mid;
                right = mid - 1;
            } else {
                left = mid + 1;
            }
        }

        // --- binary search: last index <= end ---
        left = 0;
        right = list.length - 1;
        let endIdx = -1;

        while (left <= right) {
            let mid = (left + right) >> 1;
            let ts = new Date(list[mid].observedTime).getTime();

            if (ts <= end) {
                endIdx = mid;
                left = mid + 1;
            } else {
                right = mid - 1;
            }
        }

        // return the range
        return startIdx <= endIdx ? list.slice(startIdx, endIdx + 1) : [];
    }



    //Cache-loading functions
    const loadPatientModeApData = async () => {
        if (props?.PatientHistoryTimeData && Object.keys(props?.PatientHistoryTimeData).length > 0) {
            if (props?.PatientHistoryPatientModeAPData && Object.keys(props?.PatientHistoryPatientModeAPData).length > 0 && !(props.PatientHistoryPatientModeAPData?.isLoading)) {
                // console.log("PatientHistoryPatientModeAPData avaliable in redux")
                //Set the cursor data from cache
                let cachePatientModeAPData = props.PatientHistoryPatientModeAPData?.patientModeApdata
                setPatientModeAPData(cachePatientModeAPData);
            }
            else {
                try {
                    // console.log("PatientHistoryPatientModeAPData not avaliable in cache,.....Calling getV730iPatientHistoryPatientModeAPData API")

                    //Set isLoading true for cursor data
                    props.ventilatorPatientHistoryPatientModeAPData({
                        bedId: props.bedId,
                        isLoading: true,
                        patientModeApdata: {}
                    })

                    const apiObj = {
                        bedId: props.bedId,
                        startDateTime: props.PatientHistoryTimeData?.startDateTime,
                        endDateTime: props.PatientHistoryTimeData?.endDateTime,
                    };
                    const res = await getV730iPatientHistoryPatientModeAPData(apiObj);

                    setPatientModeAPData(res.data);

                    props.ventilatorPatientHistoryPatientModeAPData({
                        bedId: props.bedId,
                        isLoading: false,
                        patientModeApdata: res.data,
                    }) //Dispatch isLoading false + new-Data

                } catch (err) {
                    console.log("Error in getV730iPatientHistoryPatientModeAPData api :", err);
                }
            }
        } else {
            console.log("PatientHistoryTimeData not avaliable in redux")
        }
    }
    const loadLiveAlarmHistoryData = async () => {
        if (props?.PatientHistoryTimeData && Object.keys(props?.PatientHistoryTimeData).length > 0) {
            if (props?.PatientHistoryLiveAlarmHistoryData && Object.keys(props?.PatientHistoryLiveAlarmHistoryData).length > 0 && !(props.PatientHistoryLiveAlarmHistoryData?.isLoading)) {
                // console.log("PatientHistoryLiveAlarmHistoryData avaliable in redux")
                //Set the cursor data from cache
                let cacheLiveAlarmHistory = props.PatientHistoryLiveAlarmHistoryData?.liveAlarmHistory
                setLiveAlarmHistory(cacheLiveAlarmHistory);
            }
            else {
                try {
                    // console.log("PatientHistoryLiveAlarmHistoryData not avaliable in cache,.....Calling getV730iPatientHistoryLiveAlarmHistoryData API")

                    //Set isLoading true for cursor data
                    props.ventilatorPatientHistoryLiveAlarmHistoryData({
                        bedId: props.bedId,
                        isLoading: true,
                        liveAlarmHistory: {}
                    })

                    const apiObj = {
                        bedId: props.bedId,
                        startDateTime: props.PatientHistoryTimeData?.startDateTime,
                        endDateTime: props.PatientHistoryTimeData?.endDateTime,
                    };

                    const res = await getV730iPatientHistoryLiveAlarmHistoryData(apiObj);

                    setLiveAlarmHistory(res.data);

                    props.ventilatorPatientHistoryLiveAlarmHistoryData({
                        bedId: props.bedId,
                        isLoading: false,
                        liveAlarmHistory: res.data,
                    }) //Dispatch isLoading false + new-Data

                } catch (err) {
                    console.log("Error in getV730iPatientHistoryLiveAlarmHistoryData api :", err);
                }
            }
        } else {
            console.log("PatientHistoryTimeData not avaliable in redux")
        }
    }
    const loadAdditionalFeaturesData = async () => {
        if (props?.PatientHistoryTimeData && Object.keys(props?.PatientHistoryTimeData).length > 0) {
            if (props?.PatientHistoryAdditionalFeatures && Object.keys(props?.PatientHistoryAdditionalFeatures).length > 0 && !(props.PatientHistoryAdditionalFeatures?.isLoading)) {
                // console.log("PatientHistoryAdditionalFeatures avaliable in redux")
                //Set the cursor data from cache
                let cacheAdditionalFeatures = props.PatientHistoryAdditionalFeatures?.additionalFeatures
                setAdditionalFeaturesHistory(cacheAdditionalFeatures);
            }
            else {
                try {
                    // console.log("PatientHistoryAdditionalFeatures not avaliable in cache,.....Calling getV730iPatientHistoryAdditionalFeaturesHistoryData API")

                    //Set isLoading true for cursor data
                    props.ventilatorPatientHistoryAdditionalFeaturesData({
                        bedId: props.bedId,
                        isLoading: true,
                        additionalFeatures: []
                    })

                    const apiObj = {
                        bedId: props.bedId,
                        startDateTime: props.PatientHistoryTimeData?.startDateTime,
                        endDateTime: props.PatientHistoryTimeData?.endDateTime,
                    };

                    const res = await getV730iPatientHistoryAdditionalFeaturesHistoryData(apiObj);

                    setAdditionalFeaturesHistory(res?.data?.additionalFeaturesData);

                    props.ventilatorPatientHistoryAdditionalFeaturesData({
                        bedId: props.bedId,
                        isLoading: false,
                        additionalFeatures: res?.data?.additionalFeaturesData,
                    }) //Dispatch isLoading false + new-Data

                } catch (err) {
                    console.log("Error in getV730iPatientHistoryAdditionalFeaturesHistoryData api :", err);
                }
            }
        } else {
            console.log("PatientHistoryTimeData not avaliable in redux")
        }
    }

    //PaitentHistory---setting time details
    useEffect(() => {

        if (props?.PatientHistoryTimeData && Object.keys(props?.PatientHistoryTimeData).length > 0
        ) {
            //Assign from Redux
            // console.log("Assign from PatientHistoryTimeData from Redux")
            let timeInfo = props.PatientHistoryTimeData

            if (timeInfo?.duration === "Custom") {
                setduration(null)
                setIsduration_custom(true)
            }
            else {
                setduration(timeInfo?.duration)
                setIsduration_custom(false)
            }
            setTrendStartDate(timeInfo?.startDate)
            setTrendStartTime(timeInfo?.startTime)
            setTrendEndDate(timeInfo?.endDate)
            setTrendEndTime(timeInfo?.endTime)
        } else {
            // console.log("Set Default duration , caluculate timestamps")
            calculateTimestamps(false, DurationOptionList[4]?.name)
        }

    }, [props.PatientHistoryTimeData])
    useEffect(() => {
        if (!props.PatientHistoryTimeData || !(Object.keys(props.PatientHistoryTimeData).length > 0)) return;
        setPatientModeAPData({});
        setLiveAlarmHistory(null)
        setAdditionalFeaturesHistory([])
        loadPatientModeApData();
        loadLiveAlarmHistoryData();
        loadAdditionalFeaturesData()
    }, [props.PatientHistoryTimeData]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    //Setting current cursor time packets
    useEffect(() => {
        if (!liveAlarmHistory || !props?.PatientHistoryCurrentCursorTime?.currentCursorTime) return;
        // console.log("props.PatientHistoryCurrentCursorTime.currentCursorTime", props.PatientHistoryCurrentCursorTime.currentCursorTime)
        // console.log("liveAlarmHistory" , liveAlarmHistory)
        const current = new Date(props.PatientHistoryCurrentCursorTime.currentCursorTime).getTime();
        let liveAlarmsPacket = null
        if (liveAlarmHistory?.dataType == "raw") {
            // console.log("raw liveAlarmData")
            if (!liveAlarmHistory?.alarms || !Array.isArray(liveAlarmHistory.alarms) || liveAlarmHistory.alarms.length == 0) return
            liveAlarmsPacket = findRawliveAlarmsPacket(current, liveAlarmHistory.alarms)
            // console.log("raw liveAlarmsPacket", liveAlarmsPacket)
            setCurrentLiveAlarmPacket(liveAlarmsPacket)
        }

        else if (liveAlarmHistory?.dataType == "scattered") {
            // console.log("scattered liveAlarmData")
            if (!liveAlarmHistory?.alarms || Object.keys(liveAlarmHistory.alarms).length == 0) return
            if (liveAlarmHistory.alarms[props.PatientHistoryCurrentCursorTime.currentCursorTime] &&
                liveAlarmHistory.alarms[props.PatientHistoryCurrentCursorTime.currentCursorTime].length > 0
            ) {
                // console.log("scattered liveAlarmsPacket", liveAlarmHistory.alarms[props.PatientHistoryCurrentCursorTime.currentCursorTime])
                setCurrentLiveAlarmPacket(liveAlarmHistory.alarms[props.PatientHistoryCurrentCursorTime.currentCursorTime])
            }
            else {
                setCurrentLiveAlarmPacket([])
            }

        }

    }, [liveAlarmHistory, props.PatientHistoryCurrentCursorTime])
    useEffect(() => {
        if (!additionalFeaturesHistory || !props?.PatientHistoryCurrentCursorTime?.currentCursorTime) return;
        // console.log("props.PatientHistoryCurrentCursorTime.currentCursorTime", props.PatientHistoryCurrentCursorTime.currentCursorTime)
        // console.log("additionalFeaturesHistory", additionalFeaturesHistory)
        const current = new Date(props.PatientHistoryCurrentCursorTime.currentCursorTime).getTime();
        if (Array.isArray(additionalFeaturesHistory) && additionalFeaturesHistory.length > 0) {
            let grouped = {};
            for (const row of additionalFeaturesHistory) {
                const { id, startTime, endTime } = row;

                if (!grouped[id]) grouped[id] = []; // in case DB returns extra IDs
                grouped[id].push({ startTime, endTime });
            }
            const featureStatus = {};
            for (const id in grouped) {
                const list = grouped[id];
                const match = findPacketBinarySearch(current, list);
                featureStatus[id] = match ? "ON" : "OFF";
            }
            setCurrentAdditionalFeaturesPacket(featureStatus)
        }
    }, [additionalFeaturesHistory, props.PatientHistoryCurrentCursorTime])
    useEffect(() => {
        if (!patientModeAPData || !props?.PatientHistoryCurrentCursorTime?.currentCursorTime)
            return;

        const current = new Date(props.PatientHistoryCurrentCursorTime.currentCursorTime).getTime();

        /* ---------------- Patient History ---------------- */
        const patientHistoryDetails = patientModeAPData?.patientHistoryDetails;
        if (Array.isArray(patientHistoryDetails) && patientHistoryDetails.length) {
            const packet = findPacketBinarySearch(current, patientHistoryDetails);

            if (packet) {
                setPatientId(`PID : ${packet.patientId}`);

                const typeMap = {
                    adult: patientTypeAdult,
                    neonatal: patientTypeNeonatal,
                    pediatric: patientTypePediatric,
                };

                setPatientTypeImg(typeMap[packet.patientType] || null);
            } else {
                setPatientId(null);
                setPatientTypeImg(null);
            }
        } else {
            setPatientId(null);
            setPatientTypeImg(null);
        }

        /* ---------------- Mode History ---------------- */
        const modeHistoryDetails = patientModeAPData?.modeHistoryDetails;
        if (Array.isArray(modeHistoryDetails) && modeHistoryDetails.length) {
            const modePacket = findPacketBinarySearch(current, modeHistoryDetails);

            if (modePacket) {
                setModeName(MODE[modePacket.modeId]?.modeName || null);
                setCurrentCursorTimeModePacket(modePacket);
            } else {
                setModeName(null);
                setCurrentCursorTimeModePacket(null);
            }
        } else {
            setModeName(null);
            setCurrentCursorTimeModePacket(null);
        }
    }, [patientModeAPData, props.PatientHistoryCurrentCursorTime]);

    const getMinEndDate = (date) => {
        const d = new Date(date);
        d.setDate(d.getDate() - 3);
        return d;
    };

    return (
        <div className="patient-history-container">

            <div className="patient-history-container-left">

                <div className="patient-history-module-details">
                    <div className="ventilator-mode-details">
                        {patientTypeImg &&
                            <img src={patientTypeImg} className="patient-type" alt="Patient Type" />
                        }

                        <div className="ventilator-mode-details-right">
                            {modeName &&
                                <div className="ventilator-mode-details-right-value">
                                    <span>{modeName}</span>
                                </div>}
                            {patientId &&
                                <div className="ventilator-mode-details-right-pid">
                                    <span>{patientId}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="ventilator-connected-modules">
                        <div className="connected-module-header">Active Modules</div>
                        <div className="connected-modules-bottom">
                            <div className="connected-module-value">
                                {currentAdditionalFeaturesPacket?.[VENTILATOR_ADDITIONAL_FEATURES.capnography] === "ON"
                                    ? "CO2"
                                    : "--"}
                            </div>
                            <div className="pipe">
                                |
                            </div>
                            {/* <div className="connected-module-value">
                                {currentAdditionalFeaturesPacket?.[VENTILATOR_ADDITIONAL_FEATURES.spo2] === "ON"
                                    ? "SPO2"
                                    : "--"}
                            </div> */}
                            {/* <div className="pipe">
                                |
                            </div> */}
                            <div className="connected-module-value">
                                {currentAdditionalFeaturesPacket?.[VENTILATOR_ADDITIONAL_FEATURES.pnumetic_nebulizer] === "ON"
                                    ? "Jet Neb"
                                    : "--"}
                            </div>
                            <div className="pipe">
                                |
                            </div>
                            <div className="connected-module-value">
                                {currentAdditionalFeaturesPacket?.[VENTILATOR_ADDITIONAL_FEATURES.aerogen_nebulizer] === "ON"
                                    ? "Mesh Neb"
                                    : "--"}
                            </div>
                        </div>
                    </div>
                    <div className="duration-input" ref={dropdownRef}>
                        <div className="duration-label">Duration</div>

                        <div className="dropdown-container">

                            {/* Trigger */}
                            <div
                                className="dropdown-trigger"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                {/* Duration label */}
                                {Isduration_custom
                                    ? "Custom"
                                    : DurationOptionList.find(
                                        (option) => option.name === duration
                                    )?.label}

                                {/* Arrow icon changes dynamically */}
                                <img
                                    className="dropdown-arrow"
                                    src={isOpen ? whiteUpArrow : whiteDownArrow}
                                    alt="▼"
                                />
                            </div>

                            {/* Dropdown Menu */}
                            {isOpen && (
                                <div className="dropdown-menu">
                                    {DurationOptionList.map((option) => (
                                        <div
                                            key={option.name}
                                            className={`dropdown-item ${duration === option.name ? "selected" : ""
                                                }`}
                                            onClick={() => {
                                                // setduration(option.name);
                                                // setIsduration_custom(false)
                                                setIsOpen(false);
                                                //Calculate timestamps 
                                                calculateTimestamps(false, option.name)

                                            }}
                                        >
                                            {option.label}
                                        </div>
                                    ))}

                                    {/* Custom */}
                                    <div
                                        className="dropdown-custom-button"
                                        onClick={() => {
                                            showCustomPopup();
                                            setIsOpen(false);
                                        }}
                                    >
                                        Custom
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="patient-history-alarms">
                    <div
                        className="alarm-container"
                        onClick={handleShowMoreVentilatorAlarmsClick}
                        id="alarm-display-bar"
                    >
                        {Array.isArray(currentLiveAlarmPacket) && currentLiveAlarmPacket.length > 0 ? (
                            <>
                                {/* Top alarm */}
                                <div className="top-alarm-container">

                                    {(currentLiveAlarmPacket?.[0]?.type === "PHYSIOLOGICAL" || currentLiveAlarmPacket?.[0]?.type === "TECHNICAL") &&
                                        getPriority(currentLiveAlarmPacket[0].priority)?.icon && (
                                            <img
                                                alt="priority icon"
                                                src={getPriority(currentLiveAlarmPacket[0].priority)?.icon || ""}
                                                className="priority"
                                            />
                                        )
                                    }
                                    {(currentLiveAlarmPacket?.[0]?.type === "OPERATIONAL") &&
                                        <img
                                            alt="priority icon"
                                            src={currentLiveAlarmPacket?.[0]?.category === "additional_feature" ? lung_svg : consolidation_svg}
                                            className="priority"
                                        />
                                    }
                                    {currentLiveAlarmPacket?.[0]?.message || ""}
                                </div>

                                {/* Alarm count + toggle arrow */}
                                <div className="alarm-number-container">
                                    {currentLiveAlarmPacket.length}
                                    {showMoreVentilatorAlarms ? (
                                        <img src={whiteUpArrow} className="arrow-icon" alt="up arrow" />
                                    ) : (
                                        <img src={whiteDownArrow} className="arrow-icon" alt="down arrow" />
                                    )}
                                </div>

                                {/* Expanded alarm list */}
                                {showMoreVentilatorAlarms && (
                                    <div className="more-alarm-container">
                                        {currentLiveAlarmPacket.map((alarm, index) => (
                                            <div className="alarm more-alarm" key={index}>

                                                {(alarm?.type === "PHYSIOLOGICAL" || alarm?.type === "TECHNICAL") &&
                                                    getPriority(alarm?.priority)?.icon && (
                                                        <img
                                                            alt="priority icon"
                                                            src={getPriority(alarm?.priority)?.icon || ""}
                                                            className="priority"
                                                        />
                                                    )
                                                }
                                                {(alarm?.type === "OPERATIONAL") &&
                                                    <img
                                                        alt="priority icon"
                                                        src={alarm?.category === "additional_feature" ? lung_svg : consolidation_svg}
                                                        className="priority"
                                                    />
                                                }
                                                {alarm?.message || ""}
                                                <span className="alarm-time">
                                                    {alarm?.observedTime
                                                        ? moment(alarm.observedTime).utcOffset(330).format("HH:mm:ss")
                                                        : ""}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        ) : (
                            // Empty or invalid data case
                            <div className="no-alarm-container">
                                <span>No active alarms</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="patient-history-graph-types">
                    {graphTypes.map((type) => (
                        <div
                            key={type.key}
                            className={`graph-type ${selectGraphType.key === type.key ? "selected" : ""}`}
                            style={{ width: type.width }}
                            onClick={() => setselectGraphType(type)}
                        >
                            {type.label}
                        </div>
                    ))}
                </div>

                <V730iParameterGraph
                    selectedParamList={selectGraphType.parameterList}
                    bedId={props.bedId}
                />
                <V730iSetParameterHistory
                    currentCursorTimeModePacket={currentCursorTimeModePacket}
                />
            </div>
            <V730iEventHistory
                bedId={props.bedId}
            />
            {isCustomPopupVisible && (
                <div className="fullscreen-overlay">
                    <div className="overlay-content">
                        <div className="top">
                            <div className="top-heading">Custom Trends</div>
                        </div>
                        <div className="middle">
                            <div className="layer1">
                                <div className="start-date">
                                    <label className="date-label">Start Date</label>
                                    <div className="date-box">
                                        <DatePicker
                                            // className="trend-date"
                                            onChange={(date) => setTrendStartDate(date)}
                                            value={trendStartDate}
                                            clearIcon={false}
                                            maxDate={trendEndDate}
                                            minDate={trendEndDate ? getMinEndDate(trendEndDate) : null}
                                        />
                                    </div>
                                </div>
                                <div className="start-time">
                                    <label className="time-label">Start Time</label>
                                    <div className="time-box">
                                        <TimePicker
                                            // className="trend-time"
                                            onChange={(date) => setTrendStartTime(date)}
                                            value={trendStartTime}
                                            clearIcon={false}
                                            disableClock={false}
                                            clockProps={{ renderNumbers: true }}
                                            format="HH:mm:ss"         // <<< ALLOW SECONDS
                                            maxDetail="second"        // <<< SHOW/EDIT SECONDS
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="layer2">
                                <div className="end-date">
                                    <label className="date-label">End Date</label>
                                    <div className="date-box">
                                        <DatePicker
                                            onChange={(date) => setTrendEndDate(date)}
                                            value={trendEndDate}
                                            clearIcon={false}
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                                <div className="end-time">
                                    <label className="time-label">End Time</label>
                                    <div className="time-box">
                                        <TimePicker
                                            // className="trend-time"
                                            onChange={(date) => setTrendEndTime(date)}
                                            value={trendEndTime}
                                            clearIcon={false}
                                            disableClock={false}
                                            format="HH:mm:ss"         // <<< ALLOW SECONDS
                                            maxDetail="second"        // <<< SHOW/EDIT SECONDS

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bottom">

                            <button className="cancel-trends" onClick={hideCustomPopup_cancel}>Cancel</button>

                            <button className="generate-trends" onClick={() => {
                                hideCustomPopup_onclick();
                            }}>Generate Trends</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    let ventilatorPatientHistoryTimeData = state.volatileDataReducer?.ventilatorPatientHistoryTimeData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryTimeData in mapProps in V730iPatientHistory", ventilatorPatientHistoryTimeData)

    let ventilatorPatientHistoryPatientModeAPData = state.volatileDataReducer?.ventilatorPatientHistoryPatientModeAPData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryPatientModeAPData in mapProps in V730iPatientHistory", ventilatorPatientHistoryPatientModeAPData)

    let ventilatorPatientHistoryCurrentCursorTime = state.volatileDataReducer?.ventilatorPatientHistoryCurrentCursorTime?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryCurrentCursorTime in mapProps in V730iPatientHistory", ventilatorPatientHistoryCurrentCursorTime)

    let ventilatorPatientHistoryLiveAlarmHistoryData = state.volatileDataReducer?.ventilatorPatientHistoryLiveAlarmHistoryData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryLiveAlarmHistoryData in mapProps in V730iPatientHistory", ventilatorPatientHistoryLiveAlarmHistoryData)

    let ventilatorPatientHistoryAdditionalFeaturesData = state.volatileDataReducer?.ventilatorPatientHistoryAdditionalFeaturesData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryAdditionalFeaturesData in mapProps in V730iPatientHistory", ventilatorPatientHistoryAdditionalFeaturesData)

    return {
        PatientHistoryTimeData: ventilatorPatientHistoryTimeData,
        PatientHistoryPatientModeAPData: ventilatorPatientHistoryPatientModeAPData,
        PatientHistoryCurrentCursorTime: ventilatorPatientHistoryCurrentCursorTime,
        PatientHistoryLiveAlarmHistoryData: ventilatorPatientHistoryLiveAlarmHistoryData,
        PatientHistoryAdditionalFeatures: ventilatorPatientHistoryAdditionalFeaturesData
    };

};

const mapDispatchToProps = (dispatch) => {
    return {
        ventilatorPatientHistoryTimeData: (payload) => dispatch(ventilatorPatientHistoryTimeData(payload)),
        ventilatorPatientHistoryPatientModeAPData: (payload) => dispatch(ventilatorPatientHistoryPatientModeAPData(payload)),
        ventilatorPatientHistoryLiveAlarmHistoryData: (payload) => dispatch(ventilatorPatientHistoryLiveAlarmHistoryData(payload)),
        ventilatorPatientHistoryAdditionalFeaturesData: (payload) => dispatch(ventilatorPatientHistoryAdditionalFeaturesData(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(V730iPatientHistory);